import errorHandler from './ErrorHandler';

const vueErrorHandler = (
	error: Error,
	vueInstance: any,
	info: string,
) => {
	// TODO: errorCaptured

	let stack = error?.stack?.replace(/ {4}at/g, '➜');

	stack = stack && stack.length > 2048 ? `${stack.slice(0, 2048)}...` : stack;

	const state = vueInstance.State
        && vueInstance.State.CurrentState
        && vueInstance.State.CurrentState.state
		? JSON.stringify(vueInstance.State.CurrentState.state).slice(0, 512)
		: 'n/a';
	const customer = vueInstance.User
		? `CID:${vueInstance.User.CustomerId || -1},UID:${
			vueInstance.User.UserId || -1
		}`
		: 'n/a';
	const additional = `userId⯈:${customer}|state⯈:${state}|width⯈:${window.innerWidth}|ua⯈:${navigator.userAgent}`;
	const msg = `[Vue:${info}] [${
		stack ? stack.split('\n').join(' ') : ''
	}] [${additional}]`;

	errorHandler(msg, document.location.href, '1', error);
};

export default vueErrorHandler;
